import React from "react";

/* Compact, recognizable payment-method marks rendered as inline SVG so we
   don't ship any image binaries. Order matches the Stripe Checkout default
   for EUR (card-first, wallets after). */

const Visa = (props) => (
  <svg viewBox="0 0 64 24" aria-label="Visa" {...props}>
    <rect width="64" height="24" rx="4" fill="#1A1F71" />
    <text x="32" y="17" textAnchor="middle" fontFamily="Inter, Arial, sans-serif"
      fontWeight="900" fontSize="14" fill="#FFFFFF" letterSpacing="2">VISA</text>
  </svg>
);

const Mastercard = (props) => (
  <svg viewBox="0 0 64 24" aria-label="Mastercard" {...props}>
    <rect width="64" height="24" rx="4" fill="#FFFFFF" stroke="#E5E7EB" />
    <circle cx="27" cy="12" r="7" fill="#EB001B" />
    <circle cx="37" cy="12" r="7" fill="#F79E1B" fillOpacity="0.95" />
    <path d="M32 7.3a7 7 0 0 0 0 9.4 7 7 0 0 0 0-9.4Z" fill="#FF5F00" />
  </svg>
);

export default function PaymentLogos({ size = 24, className = "", testid = "payment-logos" }) {
  // Only advertise methods genuinely available on the NeptunePay hosted card
  // page (BASIC_CARD): Visa and Mastercard.
  const marks = [Visa, Mastercard];
  const w = Math.round((size / 24) * 64);
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid={testid}>
      {marks.map((M, i) => (
        <M key={i} width={w} height={size} style={{ display: "block" }} />
      ))}
    </div>
  );
}
